import React, { useEffect } from "react";
import "../utils/GlobalToast.css"

const GlobalToast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;

  return (
    <div className={`toast-container ${type}`}>
      {message}
    </div>
  );
};

export default GlobalToast;
